export const expenseTypeColors = [

  { expenseTypeName: 'TRANSACTION', color: '#3B87EB' },
  { expenseTypeName: 'EXPENSE', color: '#FA9609' },
  { expenseTypeName: 'MILEAGE', color: '#469544' },
  { expenseTypeName: 'DIET', color: '#111C25' }
]
